// extracted by mini-css-extract-plugin
module.exports = {"light_share-query-description-color":"#000","dark_share-query-description-color":"#d1d1d1"};